import type { OfferModel } from '../../../offer/model/OfferModel';

export const getOpenRfqOffers = (offers: OfferModel[]) => offers.filter((offer) => !offer.isCanceled());
